var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.type === '1' ? 'donut-chart1' : 'donut-chart2'},[_c('div',{class:_vm.type === '1' ? 'chart-container1' : 'chart-container2'},[_c('highcharts',{attrs:{"options":_vm.options}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }